const formatPrice = value => parseFloat(value / 100).toFixed(2)

export default formatPrice
